import { mountVueComponent } from '@/lib/mount-vue-component';
export default () => {
  import(
    '@/modules/payment-schedule-templates/components/PaymentScheduleTemplatesList'
  ).then(PaymentScheduleTemplatesList =>
    mountVueComponent('payment-schedule-templates-list', PaymentScheduleTemplatesList)
  );
};
